import { darken, lighten } from "@material-ui/core";
import { novaTheme } from "./mockThemes";

const COFFICIENT = 0.8;

const leoThemePicker = (theme) => {
  try {
    return {
      palette: {
        type: theme.theme_mode || "light",
        primary: {
          main: theme.primary_color,
          light: lighten(theme.primary_color, COFFICIENT),
          dark: darken(theme.primary_color, COFFICIENT),
          contrastText: theme.primary_text_color,
          foreground: theme.primary_text_color,
        },
        secondary: {
          main: theme.secondary_color,
          light: lighten(theme.secondary_color, COFFICIENT),
          dark: darken(theme.secondary_color, COFFICIENT),
          contrastText: theme.secondary_text_color,
          foreground: theme.secondary_text_color,
        },
      },
      agentTheme: {
        background: {
          main: theme.page_background,
          primary_text: theme.h1_color,
          secondary_text: theme.h2_color,
        },
        primary: {
          main: theme.primary_color,
          light: lighten(theme.primary_color, COFFICIENT),
          dark: darken(theme.primary_color, COFFICIENT),
          foreground: theme.primary_text_color,
          secondary_foreground: theme.primary_text_color,
        },
        secondary: {
          main: theme.secondary_color,
          light: lighten(theme.secondary_color, COFFICIENT),
          dark: darken(theme.secondary_color, COFFICIENT),
          foreground: theme.secondary_text_color,
          secondary_foreground: theme.secondary_text_color,
        },
        accent: {
          main: theme.accent_background,
          foreground: theme.accent_text_color,
        },
        shade: {
          starRating: theme.secondary_color,
        },
        success: {
          main: theme.success_background,
          light: lighten(theme.success_background, COFFICIENT),
        },
        destructive: {
          main: theme.error_background,
          light: lighten(theme.error_background, COFFICIENT),
        },
        card: {
          main: theme.card_background,
          foreground: theme.h3_color,
          secondary_foreground: theme.body_text_color,
          tertiary_foreground: theme.h4_color,
          muted_foreground: theme.small_text_color,
          link_foreground: theme.link_text_color,
        },
        text: {
          h1_color: theme.h1_color,
          h2_color: theme.h2_color,
          h3_color: theme.h3_color,
          h4_color: theme.h4_color,
          body_text_color: theme.body_text_color,
          small_text_color: theme.small_text_color,
          link_text_color: theme.link_text_color,
        },
        border: {
          main: theme.primary_color,
          secondary: theme.secondary_color,
          primary: theme.primary_color,
        },
      },
      overrides: {
        MuiCheckbox: {
          colorPrimary: {
            "&$checked": { color: theme.primary_color },
          },
          colorSecondary: {
            "&$checked": { color: theme.primary_color },
          },
          root: {
            color: theme.primary_color,
          },
        },
        MuiRadio: {
          colorPrimary: { "&$checked": { color: theme.primary_color } },
          colorSecondary: { "&$checked": { color: theme.primary_color } },
          root: { color: theme.primary_color },
        },
        MuiCssBaseline: {
          "@global": {
            html: {
              backgroundColor: theme.page_background,
            },
            body: {
              backgroundColor: `inherit !important`,
            },
          },
        },
        MuiPaper: {
          root: {
            backgroundColor: theme?.page_background,
          },
        },
        MuiButton: {
          containedPrimary: {
            backgroundColor: theme.primary_color,
            "&:hover": {
              backgroundColor: theme.primary_color,
            },
          },
          containedSecondary: {
            backgroundColor: theme.secondary_color,
            "&:hover": {
              backgroundColor: theme.secondary_color,
            },
          },
        },
        MuiCard: {
          root: {
            backgroundColor: theme.card_background,
          },
        },
        MuiDialog: {
          paper: {
            backgroundColor: theme.page_background,
          },
        },
        MuiDialogContent: {
          root: {
            backgroundColor: `${theme.page_background} !important`,
          },
        },
      },
      typography: {
        fontFamily: theme.font_name || "Roboto, Arial, sans-serif",
      },
      zIndex: {
        modal: 99999,
      },
      spacingRules: {
        cardPaddingDesktop: "2rem",
        cardPaddingMobile: "1rem",
      },
    };
  } catch (error) {
    // Nova Theme is a default color pallete. It will be used if theme is not defined or invalid color pallete
    return leoThemePicker(novaTheme);
  }
};

const loadFont = (link) => {
  const element = document.createElement("link");
  element.href = link;
  element.rel = "stylesheet";
  element.onload = () => {
    console.log("link", `${link} Loaded`);
  };
  element.onerror = () => {
    console.error("link", `${link} failed`);
  };
  document.head.appendChild(element);
};

const defineThemeEngine = (templateType) => {
  const { templateTheme } = templateType;

  const theme = templateTheme ? templateTheme : novaTheme;

  loadFont(theme.font_link || novaTheme.font_link);

  return leoThemePicker(theme);
};

export default defineThemeEngine;
